var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"view-ellipsis",class:_vm.classes},[_c('span',{staticClass:"view-ellipsis-bullet"},[_vm._v(".")]),_c('span',{staticClass:"view-ellipsis-bullet"},[_vm._v(".")]),_c('span',{staticClass:"view-ellipsis-bullet"},[_vm._v(".")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b29c92b2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/snippets/Ellipsis.vue
// module id = 377
// module chunks = 0